import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features-cards',
  templateUrl: './features-cards.component.html',
  styleUrls: ['./features-cards.component.scss']
})
export class FeaturesCardsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
